import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Article } from '../types/items';
import {
  updateProcessingMediaArticleSuccess,
} from '../store/modules/articles/actions';
import ArticleService from '../services/ArticleService';
import { errorNotify } from '../store/modules/notifications/actions';

const useMediaItemWatcher = (media: Article) => {
  const mediaId = media.id;

  const isVideoProcessing = media.ref.video?.ref.is_processing;
  const isDocumentProcessing = media.ref.document?.ref.is_processing;
  const isVideoUploading = media.ref.video?.ref.is_uploading;
  const isDocumentUploading = media.ref.document?.ref.is_uploading;
  const isUploading = isVideoUploading || isDocumentUploading || false;
  const isProcessing = isVideoProcessing || isDocumentProcessing || false;


  const updatePeriod = 1000 * 20; // 20 sec
  const dispatch = useDispatch();

  // update processing media item
  useEffect(() => {
    let timerId: NodeJS.Timeout|null = null;

    if (isProcessing || isUploading) {

      const pingItem = async () => {
        try {
          if (Number.isNaN(Number(mediaId))) {
            throw new Error('Invalid article id');
          }
          const response = await ArticleService.get(mediaId);
          if (response) {
            dispatch(updateProcessingMediaArticleSuccess(response));
          }
        } catch (e) {
          dispatch(errorNotify('An Error Occurred'));
          if (timerId) clearInterval(timerId);
        }
      };

      timerId = setInterval(() => {
        if (!mediaId && timerId) {
          clearInterval(timerId);
          return;
        }

        pingItem();
      }, updatePeriod);
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [mediaId, isProcessing, isUploading, updatePeriod, dispatch]);

  return null;
};

export default useMediaItemWatcher;
